var map = {
	"./basketball.jpg": 21188,
	"./dpe.jpg": 31032,
	"./gym.jpg": 16692,
	"./indoorstadium.jpg": 70531,
	"./indoorstadium_inside.jpg": 37312,
	"./kabadi.jpg": 32207,
	"./playground.jpg": 30334,
	"./tabletennis.JPG": 70529,
	"./track.jpg": 58544,
	"./volleyball.jpg": 87505,
	"./volleyball2.jpg": 82239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67797;